let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fkpZe")).then(() => parcelRequire('jrWYq'));